<template>
  <table class="table table-striped text-center">
    <thead>
    <tr>
      <th scope="col" width="15%">Nombre</th>
      <th scope="col" width="5%">Tipo</th>
      <th scope="col" width="5%">Etiquetas</th>
      <th scope="col" width="30%" >Texto</th>
      <th scope="col">Reglas</th>
      <th scope="col" width="7%">Activado</th>
      <th scope="col" width="7%">Modificar</th>
      <th scope="col" width="7%">Eliminar</th>
    </tr>
    </thead>
    <tbody>
    <notifications-table-row
            v-for="notification in notifications"
            :notification="notification"
            :key="notification.id"
            @error="onComponentError"
            @success="onComponentSuccess"
    />
    </tbody>
  </table>
</template>

<script>

import NotificationsTableRow from '@/components/NotificationsTableRow.vue'

export default {
    name: 'notifications-table',
    components: {
      'notifications-table-row' : NotificationsTableRow
    },
    props: ['notifications'],
    methods : {
        onComponentError (message) {
            this.$emit('error', message);
        },
        onComponentSuccess (message) {
            this.$emit('success', message);
        }
    }
}
</script>

<style>
  .table {
  margin: auto;
  width: 90% !important;
  }
</style>
